import React from 'react';
import { ProviderInput } from '../../components/input/ProviderInput';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const ProviderPicker = ({
  onChange,
  schema: { title = 'Provider', description = 'Select a cloud provider' },
  required,
  rawErrors,
  formData,
  idSchema,
  formContext,
}: FieldExtensionComponentProps<string>) => {
  return (
    <ProviderInput
      label={title}
      helperText={description}
      error={rawErrors && rawErrors.length > 0 && !formData}
      required={required}
      id={idSchema?.$id}
      onChange={onChange}
      product={formContext.formData.product}
      team={formContext.formData.team}
      value={formData as string}
    ></ProviderInput>
  );
};
